import UserKYC from "./UserKYC.container";
export default UserKYC;
